import {  useParams } from "react-router-dom";
import SaveCapacidadCorporativa from "../../shared/componente/SavePlanesCorporativos";
// import { useGetCapacidadCorporativoById } from "@/shared/actions/erp/planes/planes_corporativos.actions";
import { LoaderComponent } from "@/shared/components/ui";
import { useEffect } from "react";
import { useGetPlanCorporativoById } from "@/shared/actions/erp/planes";

export default function EditarPlanCorporativoPage() {

  const { id } = useParams()

  if (!id) return null;

  const { data, isLoading } = useGetPlanCorporativoById(id)

  useEffect(() => {
    if (isLoading || data) return
  }, [isLoading, data])

  if (isLoading) return <LoaderComponent />

  if (!data) return null;
  return (
    <SaveCapacidadCorporativa titlePage="Editar Plan Corporativo" planCorporativo={data} />
  )

}